import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { HttpServiceBase } from '../classes/HttpServiceBase';

export interface EquipmentSpec {
    label: string;
    value: string;
}

export interface EquipmentSummary {
    id: string;
    code: string;
    slug: string;
    name: string | null;
    image: string | null;
}

export interface Equipment extends EquipmentSummary {
    features: string | null;
    specifications: EquipmentSpec[];
}

/** The public product catalogue (Fyes_Equipment). */
@Injectable({ providedIn: 'root' })
export class EquipmentService extends HttpServiceBase {
    protected override baseUrl = '/equipment';

    constructor(private http: HttpClient) {
        super();
        this.assign(this);
    }

    public list(): Observable<any> {
        return this._http.get(this.baseUrl)
            .pipe(map((r: any) => r), catchError(this.handleError.bind(this)));
    }

    public bySlug(slug: string): Observable<any> {
        return this._http.get(`${this.baseUrl}/${encodeURIComponent(slug)}`)
            .pipe(map((r: any) => r), catchError(this.handleError.bind(this)));
    }
}
